import employeesApi from 'Api/axios/employees-api';
import { useCallback, useEffect, useState } from 'react';
import type { GetUserCoursesResponse } from 'types';

interface Props {
  init?: boolean;
  userId?: string;
  assigned?: boolean;
  enrolled?: boolean;
}

/**
 * Obtiene los cursos de un empleado, puedes especificar si el curso
 * fue de inscripción manual o no. Además, tambien puedes obtener todos
 * aquellos cursos que no tiene.
 * @returns
 */
const useUserCourses = ({ init = false, userId, assigned = true, enrolled = false }: Props = {}) => {
  const [data, setData] = useState<GetUserCoursesResponse[]>();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | undefined>();

  const fetch = useCallback(
    async (userId: string) => {
      setLoading(true);
      const response = await employeesApi.getCourses(userId, {
        assigned,
        enrolled,
      });
      setLoading(false);
      if (response.error) {
        setError(response.error);
        return;
      }
      setData(response.data);
    },
    [assigned, enrolled]
  );

  useEffect(() => {
    if (init && userId) {
      fetch(userId);
    }
  }, [init, userId, fetch]);

  return {
    courses: data,
    loading,
    fetch,
    error,
  };
};

export default useUserCourses;
